import Vue from 'vue'
import Router from 'vue-router'

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views mantencion 
const Dashboard = () => import('@/views/Dashboard')
const Error = () => import('@/views/Error')

// Views Consulta Clientes
const BusquedaPersonas = () => import('@/views/consulta-clientes/busqueda-personas')

Vue.use(Router)

export default new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/inicio',
      name: 'Inicio',
      component: DefaultContainer,
      children: [
        {
          path: '403',
          name: 'Error',
          component: Error,
        },
        {
          path: 'inicio',
          name: 'Inicio',
          //component: Dashboard
        },
        {
          path: '/consulta-clientes',
          redirect: '/consulta-clientes/busqueda-personas',
          name: 'Consulta Clientes',
          component: {
            render(c) { return c('router-view') }
          },
          children: [{
            path: 'busqueda-personas',
            name: 'Busqueda de Personas',
            component: BusquedaPersonas,

          }
          ]
        },
        

        
      ]
    }
  ]
})
